import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/* eslint-disable no-plusplus */
import React from 'react';
import PropTypes from 'prop-types';
import Card from 'orion/lib/card';
import Row from 'orion/lib/row';
import Col from 'orion/lib/col';
import DetailsItem from '../sharedComponent/detailsItem';

var AlertDetailsCard = function AlertDetailsCard(_ref) {
  var _context;

  var alert = _ref.alert;
  var attributes = alert.data.attributes; // filter out elements to show in Details section

  var detailsToShow = _filterInstanceProperty(_context = attributes || []).call(_context, function (attribute) {
    return attribute.displayOnUi === true;
  });

  var numberOfRows = Math.ceil(detailsToShow.length / 4);
  var counter = 0;
  return /*#__PURE__*/React.createElement(Card, {
    title: "Details",
    className: "oui-mt-3",
    body: function body() {
      var _context2;

      var details = _mapInstanceProperty(_context2 = _toConsumableArray(Array(numberOfRows))).call(_context2, function () {
        return /*#__PURE__*/React.createElement(Row, {
          className: "oui-pt-3 oui-pb-3",
          key: "details-row-".concat(counter)
        }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DetailsItem, {
          details: detailsToShow[counter++]
        })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DetailsItem, {
          details: detailsToShow[counter++]
        })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DetailsItem, {
          details: detailsToShow[counter++]
        })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DetailsItem, {
          details: detailsToShow[counter++]
        })));
      });

      return /*#__PURE__*/React.createElement(React.Fragment, null, details);
    }
  });
};

AlertDetailsCard.propTypes = {
  alert: PropTypes.object.isRequired
};
export default AlertDetailsCard;